import { defineWebModule } from '@portal/web-sdk';
import { manifest } from '../manifest.js';
import { en, vi } from './translations.js';

export const coreAccessWebModule = defineWebModule({
  manifest,
  translations: { vi, en },
  routes: [
    { path: '/admin/roles', component: () => import('./pages/RolesPage.js') },
    { path: '/admin/roles/$roleId', component: () => import('./pages/RoleDetailPage.js') },
  ],
});
